/**
 * React Query cache keys for the enroll queue's own endpoints — moved out of
 * `EnrollQueueContext.tsx` (F9 god-context cut 2 of 4) so both the extracted
 * `useEnrollQueueQueries` hook (the readers) and the context file's mutations
 * (the invalidators, which stay put for the F1/DBOS worktree) can share them
 * without either importing the other.
 */
export const QUEUE_KEY = ['flow-queue'] as const;
/**
 * Exported so Play Manager admin mutations (PlaysPage pause/resume/save)
 * can invalidate the picker's catalog — cache-indefinitely +
 * invalidate-on-mutation across surfaces in the one SPA. Without this, a
 * play paused in /admin/configuration/plays kept showing in the queue
 * picker until a full reload.
 */
export const FLOW_QUEUE_PLAYS_KEY = ['flow-queue-plays'] as const;
export const SENDERS_KEY = ['flow-queue-senders'] as const;
export const INPUT_OPTIONS_KEY = ['flow-queue-input-options'] as const;
